// extracted by mini-css-extract-plugin
export default {"appContainer":"App_appContainer__Q73Qs","inputsContainer":"App_inputsContainer__QDVPE"};